



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AlbumMediaItem from '@/components/AlbumMediaItem.vue'
import { AlbumFormat } from '@/components/types'
import { createNamespacedHelpers } from 'vuex'
import MediaItem = gapi.client.photoslibrary.MediaItem;

const { mapActions, mapState } = createNamespacedHelpers('photos')

@Component({
  components: {
    AlbumMediaItem
  },
  computed: mapState([
    'album',
    'mediaItem',
    'mediaItems'
  ]),
  methods: mapActions([
    'getAlbum',
    'viewMediaItem'
  ])
})
export default class Album extends Vue {
  @Prop(String) readonly albumId!: string;

  album!: gapi.client.photoslibrary.Album|null;
  format: AlbumFormat = AlbumFormat.Photo;
  mediaItem!: MediaItem|null;
  mediaItems!: MediaItem[];

  @Watch('albumId')
  getAlbum!: Function;
}
